"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "eiendom", {
    enumerable: true,
    get: function() {
        return eiendom;
    }
});
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _spesial = require("./spesial");
var _kodeliste = require("./kodeliste");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var eiendom = {
    navn: "Eiendom",
    description: "Denne transformeren benyttes for \xe5 vise full adresse for eiendommen",
    transform: function transform(data, options) {
        var _options_inntektsaar = options.inntektsaar, inntektsaar = _options_inntektsaar === void 0 ? "2018" : _options_inntektsaar, intl = options.intl;
        var txtKommune;
        if (data.kommunenummer) {
            txtKommune = intl.formatMessage({
                id: (0, _kodeliste.kodelisteId)("".concat(inntektsaar, "_aktiveKommunenummer.").concat(data.kommunenummer))
            });
        }
        return /*#__PURE__*/ _react.default.createElement("div", null, data.kommunenummer && txtKommune && /*#__PURE__*/ _react.default.createElement("div", null, data.kommunenummer, " ", txtKommune), /*#__PURE__*/ _react.default.createElement("div", null, _spesial.bolig.transform({}, data, options)));
    }
};
